import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from 'react';
import Header from '../Components/Header/Header';
const API_BASE = process.env.REACT_APP_API_URL || 'https://api.heresmyinfo.com/api';
export default function DBUsers() {
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [users, setUsers] = useState([]);
  useEffect(() => {
    let mounted = true;
    setLoading(true);
    const token = localStorage.getItem('HMI_AUTH_TOKEN');
    fetch(`${API_BASE}/admin/users`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }).then(res => res.ok ? res : Promise.reject(res)).then(res => res.json()).then(data => {
      if (!mounted) return;
      // eslint-disable-next-line no-mixed-operators
      if (data.success) setUsers(data.data && data.data.users || data.users || []);else setError(data.error?.message || 'Failed to load users');
    }).catch(err => {
      if (!mounted) return;
      setError(typeof err === 'string' ? err : err.statusText || 'Request failed');
    }).finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);
  return <>
      <Header />
      <div style={{
      padding: 20
    }}>
        <h2>{t("Postgres Users")}</h2>
        {loading && <p>{t("Loading...")}</p>}
        {error && <p style={{
        color: 'red'
      }}>{error}</p>}
        {!loading && !error && <div style={{
        overflowX: 'auto'
      }}>
            <table style={{
          width: '100%',
          borderCollapse: 'collapse'
        }}>
              <thead>
                <tr>
                  <th style={{
                textAlign: 'left',
                borderBottom: '1px solid #ddd',
                padding: '8px'
              }}>{t("objectId")}</th>
                  <th style={{
                textAlign: 'left',
                borderBottom: '1px solid #ddd',
                padding: '8px'
              }}>{t("username")}</th>
                  <th style={{
                textAlign: 'left',
                borderBottom: '1px solid #ddd',
                padding: '8px'
              }}>{t("email")}</th>
                  <th style={{
                textAlign: 'left',
                borderBottom: '1px solid #ddd',
                padding: '8px'
              }}>{t("createdAt")}</th>
                  <th style={{
                textAlign: 'left',
                borderBottom: '1px solid #ddd',
                padding: '8px'
              }}>{t("updatedAt")}</th>
                </tr>
              </thead>
              <tbody>
                {users.map(u => <tr key={u.objectId}>
                    <td style={{
                borderBottom: '1px solid #f2f2f2',
                padding: '8px'
              }}>{u.objectId}</td>
                    <td style={{
                borderBottom: '1px solid #f2f2f2',
                padding: '8px'
              }}>{u.username}</td>
                    <td style={{
                borderBottom: '1px solid #f2f2f2',
                padding: '8px'
              }}>{u.email}</td>
                    <td style={{
                borderBottom: '1px solid #f2f2f2',
                padding: '8px'
              }}>{u.createdAt}</td>
                    <td style={{
                borderBottom: '1px solid #f2f2f2',
                padding: '8px'
              }}>{u.updatedAt}</td>
                  </tr>)}
              </tbody>
            </table>
            {users.length === 0 && <p>{t("No users found.")}</p>}
          </div>}
      </div>
    </>;
}